import type { TokenPair } from '@tasks/contracts/auth';

const CHANNEL = 'tasks.auth';

export type AuthBroadcast = { kind: 'rotated'; pair: TokenPair } | { kind: 'signed-out' };

export type TabChannel = {
  post: (message: AuthBroadcast) => void;
  subscribe: (listener: (message: AuthBroadcast) => void) => () => void;
  close: () => void;
};

const noop: TabChannel = {
  post: () => undefined,
  subscribe: () => () => undefined,
  close: () => undefined,
};

/** Difunde la rotación a las demás pestañas para que no llamen a /auth/refresh con un token muerto. */
export const createTabChannel = (): TabChannel => {
  if (typeof BroadcastChannel === 'undefined') return noop;
  const channel = new BroadcastChannel(CHANNEL);
  return {
    post: (message) => {
      channel.postMessage(message);
    },
    subscribe: (listener) => {
      const handler = (event: MessageEvent<AuthBroadcast>): void => {
        listener(event.data);
      };
      channel.addEventListener('message', handler);
      return () => {
        channel.removeEventListener('message', handler);
      };
    },
    close: () => {
      channel.close();
    },
  };
};
